import IFormPostHandler from './IFormPostHandler';

export default class PassThroughFormPostHandler implements IFormPostHandler {
  async post() {
    return {
      validationResult: {
        isValid: true,
        validationResults: [],
      },
    };
  }
}
